import { Table } from 'antd';
import { formatPrice } from '../../../util/formatPrice';

export function TableFooterTotal({ totals }) {
  return (
    <>
      {totals &&
        totals.map((total) => (
          <Table.Summary.Row>
            <Table.Summary.Cell
              index={0}
              colSpan={6}
              align="right"
              className="gx-border-0 gx-text-right gx-px-4 gx-pt-3 gx-pb-3"
            >
              <strong>{total?.label ?? ''}</strong>
            </Table.Summary.Cell>
            <Table.Summary.Cell
              index={6}
              align="right"
              className="gx-border-0 gx-text-right gx-text-nowrap gx-px-4 gx-pt-3 gx-pb-3"
            >
              <strong>{formatPrice(total?.total ?? 0)}</strong>
            </Table.Summary.Cell>
          </Table.Summary.Row>
        ))}
    </>
  );
}
